/**
 * useAppEnv — which deployment this is and which schedulers it runs
 * (GET /app-env). Fetched once per session; it cannot change under a page.
 * For Media Devoted | Created By James Alexandrov
 */

import { useQuery } from "@tanstack/react-query";
import type { AppEnvInfo } from "@trafficpulse/shared";

import api from "@/services/api";
import { setReportingCurrency } from "@/lib/reporting-currency";

export const appEnvKeys = { all: ["app-env"] as const };

/** `enabled: false` reads only what is already cached (no request) — for a
 *  caller that needs /app-env only once some registry capability is on. */
export function useAppEnv({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: appEnvKeys.all,
    queryFn: () =>
      api.get<{ data: AppEnvInfo }>("/app-env").then((r) => {
        // 28/10/2026 — the one currency every tracker's money is shown in.
        setReportingCurrency(r.data.data.reportingCurrency);
        return r.data.data;
      }),
    staleTime: Infinity,
    enabled,
  });
}
